import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
import BaseModal, { BaseModalContent } from '../BaseModal';

const SelectCreditCardInformationModal = (props) => {
  const {verifyModal, setVerifyModal} = props;
  const errorsMessage = useSelector((state) => state?.exitOrderReducer?.buyPemitCheckCreditCradDetails?.name)

  const handleClose = () => {
    setVerifyModal(false)
  }

  return (
    <>
      <BaseModal
        title="Credit Card Verification"
        align="center"
        open={verifyModal}
        with={500}
      >
        <BaseModalContent>
          <span>{errorsMessage && errorsMessage?.errorMessage}</span>
          <br/><br/>
          <Button
            style={{ float: "right", backgroundColor: "#20419a", color: "white" }}
            variant="contained"
            onClick={handleClose}
          >
            close
          </Button>
        </BaseModalContent>
      </BaseModal>
    </>
  );
};

export default SelectCreditCardInformationModal;
  